/**
 * Shared constants, formatters, and config for the Pharmacy Report module.
 */
export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const STATUS_CONFIG = {
  301: { label: "Pending", color: "text-amber-600", bg: "bg-amber-50", border: "border-amber-200", dot: "bg-amber-400" },
  302: { label: "Partial", color: "text-orange-600", bg: "bg-orange-50", border: "border-orange-200", dot: "bg-orange-400" },
  303: { label: "Paid", color: "text-emerald-600", bg: "bg-emerald-50", border: "border-emerald-200", dot: "bg-emerald-400" },
  304: { label: "Cancelled", color: "text-slate-500", bg: "bg-slate-50", border: "border-slate-200", dot: "bg-slate-400" },
  305: { label: "Refunded", color: "text-red-600", bg: "bg-red-50", border: "border-red-200", dot: "bg-red-400" },
  306: { label: "Insurance Credit", color: "text-blue-600", bg: "bg-blue-50", border: "border-blue-200", dot: "bg-blue-400" },
  307: { label: "Self Credit", color: "text-violet-600", bg: "bg-violet-50", border: "border-violet-200", dot: "bg-violet-400" },
};

export const PIE_COLORS = ["#10b981", "#f59e0b", "#ef4444", "#6366f1", "#8b5cf6", "#0d9488", "#ec4899"];

export const formatCurrency = (v) => {
  if (!v && v !== 0) return "\u20B90.00";
  return new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(v);
};

export const formatCompact = (v) => {
  if (!v && v !== 0) return "\u20B90";
  const sign = v < 0 ? "-" : "";
  const abs = Math.abs(v);
  if (abs >= 10000000) return `${sign}\u20B9${(abs / 10000000).toFixed(2)}Cr`;
  if (abs >= 100000) return `${sign}\u20B9${(abs / 100000).toFixed(2)}L`;
  if (abs >= 1000) return `${sign}\u20B9${(abs / 1000).toFixed(1)}K`;
  return formatCurrency(v);
};

export const formatDateIST = (dateStr) => {
  if (!dateStr) return "-";
  try {
    const d = new Date(dateStr);
    return d.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric", timeZone: "Asia/Kolkata" });
  } catch { return dateStr; }
};

export const formatTimeIST = (dateStr) => {
  if (!dateStr) return "";
  try {
    const d = new Date(dateStr);
    return d.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", hour12: true, timeZone: "Asia/Kolkata" });
  } catch { return ""; }
};

export const formatMode = (m) => {
  if (!m) return "-";
  const MAP = { CASH: "Cash", CREDIT_CARD: "Card", DEBIT_CARD: "Card", UPI: "UPI", CREDIT: "Credit", EFT: "EFT", FREE: "Free" };
  return MAP[m] || m;
};

export const formatDoctor = (name) => {
  if (!name) return "-";
  if (/^(Dr|Prof|Mr|Mrs|Ms)\.?\s/i.test(name)) return name;
  return `Dr. ${name}`;
};
